import {
	formatISOToReadable
} from '../../../../shared/lib/DateAndTieHelpers/fromISOToReadable'
import { snakeToSentence } from '../../../../shared/lib/caseConverters/snakeToSentence'

interface Props {
	columnId: string
	value: unknown
}

export const LicenseEventsCell = ({ columnId, value }: Props) => {
	switch (columnId) {
		case 'updateTime':
			return <>{formatISOToReadable(value as string ?? '')}</>
		case 'eventName':
			return <>{snakeToSentence(value as string ?? '')}</>
		default:
			return <>{value ?? ''}</>
	}
}